import { render, staticRenderFns } from "./GetApp.vue?vue&type=template&id=4ed9d786&scoped=true"
import script from "./GetApp.vue?vue&type=script&lang=js"
export * from "./GetApp.vue?vue&type=script&lang=js"
import style0 from "./GetApp.vue?vue&type=style&index=0&id=4ed9d786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9d786",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
